import { useState } from "react";
import { useClosetItemInShortReview, useMoveToNextClosetItemReview } from "@hooks/use-review-short";
import { postOrUpdateReview } from "@utils/call-api/reviews-call";
import FitSatisfactionStep from "./FitSatisfactionStep";
import FitStep from "./FitStep";

function ClosetItemReviewShort({ scrollToTop }) {
  const closetItem = useClosetItemInShortReview();
  const moveToNextClosetItemReview = useMoveToNextClosetItemReview();

  const [step, setStep] = useState("fit_satisfaction");
  const [fitSatisfaction, setFitSatisfaction] = useState(null);

  function onSelectFitSatisfaction(value) {
    setFitSatisfaction(value);
    setStep("fit");
    scrollToTop();
  }

  async function onSelectFit(value) {
    const data = {
      review: {
        fit_satisfaction: fitSatisfaction,
        fit: value,
      },
    };

    postOrUpdateReview(closetItem, data);
    moveToNextClosetItemReview();
    setStep("fit_satisfaction");
    scrollToTop();
    setFitSatisfaction(null);
  }

  if (!closetItem) return null;

  return (
    <div className="px-3 py-5">
      {step === "fit_satisfaction" && (
        <FitSatisfactionStep
          onSelect={onSelectFitSatisfaction}
          scrollToTop={scrollToTop}
        />
      )}

      {step === "fit" && <FitStep onSelect={onSelectFit} />}
    </div>
  );
}

export default ClosetItemReviewShort;
